import { createRoute } from "@tanstack/react-router";

import validation from "core/validation";
import { root } from "routes";

import Layout from "theme/ui/Layout";

import History from "areas/account/pages/History";
import Profile from "areas/account/pages/Profile";
import Account from "areas/account/pages/Account";
import AccountDeposits from "areas/account/pages/AccountDeposits";
import AccountMethods from "areas/account/pages/AccountMethods";


const _root = createRoute({
	getParentRoute: () => root,
	path: "account",
	component: () => <Layout.Light />,
	beforeLoad: validation.redirect.unauthenticated
});

const account = createRoute({
	getParentRoute: () => _root,
	path: "/",
	component: () => <Account />
});

const profile = createRoute({
	getParentRoute: () => _root,
	path: "profile",
	component: () => <Profile />
});

const deposits = createRoute({
	getParentRoute: () => _root,
	path: "deposits",
	component: () => <AccountDeposits />
});

const methods = createRoute({
	getParentRoute: () => _root,
	path: "methods",
	component: () => <AccountMethods />
});

const history = createRoute({
	getParentRoute: () => _root,
	path: "history",
	component: () => <History />
});

const all = _root.addChildren([account, history, profile, deposits, methods]);
export default all;